import { Module } from "vuex";
import axios from "@/plugins/axios";
import router from "@/router";
import { RootState } from "@/store";
import { User } from '@/interfaces'

interface AuthState {
  token: string | null;
  user: User | null;
  errors: Array<object>;
  logging: boolean;
}

const auth: Module<AuthState, RootState> = {
  namespaced: true,
  state: () => {
    const token = localStorage.getItem("token");
    return {
      token: token,
      user: null,
      errors: [],
      logging: false
    };
  },
  mutations: {
    setToken(state, payload) {
      const { token } = payload;
      localStorage.setItem("token", token);
      state.token = token;
    },
    setUserData(state, payload) {
      const { user } = payload;
      localStorage.setItem("user", JSON.stringify(user));
      state.user = user;
    },
    setErrors(state, payload) {
      const { errors } = payload;
      state.errors = errors;
    },
    setLogging(state, payload) {
      const { logging } = payload;
      state.logging = logging;
    },
    clearAuthData(state) {
      localStorage.removeItem("token");
      state.token = null;
      state.user = null;
    }
  },
  actions: {
    login(
      { commit },
      { email, password }: { email: string; password: string }
    ): void {
      commit("setLogging", { logging: true });
      axios
        .post("/api/auth/login", {
          email,
          password
        })
        .then(({ data }) => {
          commit("setToken", { token: data.token });
          commit("setErrors", { errors: [] });
          commit("setLogging", { logging: false });
          router.push("/dashboard");
        })
        .catch(error => {
          commit("setLogging", { logging: false });
          commit("setErrors", { errors: error.response.data.errors });
        });
    },
    logout({ commit }): void {
      commit("clearAuthData");
      commit("setLoaded", { loaded: false }, { root: true });
      router.push("/");
    },
    setToken({ commit }, token: string): void {
      commit("setToken", { token });
    }
  },
  getters: {
    isAuthenticated(state): boolean {
      return Boolean(state.token);
    },
    errors(state): Array<object> {
      return state.errors;
    },
    logging(state): boolean {
      return state.logging;
    },
    user(state): User | null {
      return state.user;
    },
    userIsInMultipleDepartments(state): boolean {
      if (state.user) {
        return state.user.department.length > 1;
      }
      return false;
    }
  },
};

export default auth;
